module.exports = __webpack_public_path__ + "static/media/close.5bb294ba.svg";